/* Uncle T's — theme JS
   Scroll-scrubbed header + hero video, Greek-to-English headline morph,
   drawers/panel, reveals, review loop. Cart is wired to Shopify's Cart AJAX API. */

const ANNOUNCE = [
  "Dried fresh this week",
  "Free shipping, always",
  "Small batch. When it's gone, it's gone"
];
/* the hero headline opens in Greek, then dissolves into the English copy */
const GREEK_H1A = "Ελληνική ψυχή. Ελβετική τέχνη.";
const GREEK_H1B = "Θρυλικό τζέρκι";

const fmtCents = c => (c / 100).toFixed(2).replace(".", ",") + " €";
const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;

/* products injected by the featured-range / collection sections */
const PRODUCTS = window.UT_PRODUCTS || {};

/* ============ HEADLINE: Greek -> English crossfade ============
   The two lines are stacked: the English sits in the flow and sizes the line
   box, the Greek rides above it absolutely positioned. Only opacity animates
   (no transforms, no width transitions), so the morph stays on the compositor
   and the line never reflows — that per-character width animation was what
   made the old version stutter. */
const heroH1 = document.querySelector(".hero h1");
const GREEK_LINES = [GREEK_H1A, GREEK_H1B];
const FIT_MIN = .7;
let greekActive = false;

/* width of a string as it would render in the headline, measured off-screen */
function measureText(text, refEl){
  const cs = getComputedStyle(refEl);
  const probe = document.createElement("span");
  probe.style.cssText = "position:absolute;left:-9999px;top:0;visibility:hidden;white-space:pre";
  probe.style.fontFamily = cs.fontFamily;
  probe.style.fontSize = cs.fontSize;
  probe.style.fontWeight = cs.fontWeight;
  probe.style.letterSpacing = cs.letterSpacing;
  probe.textContent = text;
  document.body.appendChild(probe);
  const w = probe.getBoundingClientRect().width;
  probe.remove();
  return w;
}

/* Size the headline so every line — including the wider Greek, while it is
   showing — holds a single line. Below FIT_MIN we let it wrap naturally. */
function fitHeadline(smooth = true){
  if (!heroH1) return;
  const lines = Array.prototype.slice.call(heroH1.querySelectorAll(".ln"));
  if (!lines.length) return;
  const prev = heroH1.style.fontSize;
  heroH1.style.transition = "none";
  heroH1.style.fontSize = "";
  void heroH1.offsetWidth;
  const base = parseFloat(getComputedStyle(heroH1).fontSize);
  let scale = 1;
  if (!reduceMotion){
    lines.forEach((ln, idx) => {
      const i = ln.querySelector("i");
      if (!i) return;
      const avail = ln.clientWidth;
      if (!avail) return;
      const candidates = [i.dataset.en || i.textContent];
      if (greekActive && GREEK_LINES[idx]) candidates.push(GREEK_LINES[idx]);
      candidates.forEach(txt => {
        const w = measureText(txt, i);
        if (w > avail) scale = Math.min(scale, avail / w);
      });
    });
  }
  const target = (!reduceMotion && scale < 1 && scale >= FIT_MIN)
    ? (base * scale * .99).toFixed(2) + "px" : "";
  if (smooth && !reduceMotion){
    heroH1.style.fontSize = prev;
    void heroH1.offsetWidth;
    heroH1.style.transition = "";
    heroH1.style.fontSize = target;
  } else {
    heroH1.style.fontSize = target;
    void heroH1.offsetWidth;
    heroH1.style.transition = "";
  }
}
if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => fitHeadline(false));

/* split text into per-character spans (words kept unbreakable), all hidden */
function splitChars(text, target){
  const frag = document.createDocumentFragment();
  const spans = [];
  const words = text.split(" ");
  words.forEach((word, w) => {
    const wrap = document.createElement("span");
    wrap.style.cssText = "display:inline-block;white-space:nowrap";
    Array.prototype.forEach.call(word, ch => {
      const s = document.createElement("span");
      s.textContent = ch;
      s.style.cssText = "display:inline-block;opacity:0;will-change:opacity";
      wrap.appendChild(s);
      spans.push(s);
    });
    frag.appendChild(wrap);
    if (w < words.length - 1) frag.appendChild(document.createTextNode(" "));
  });
  target.textContent = "";
  target.appendChild(frag);
  return spans;
}

/* ripple a set of characters to an opacity, left to right.
   The start value is flushed with a forced reflow rather than waiting for a
   rAF callback — a backgrounded tab pauses rAF, which would otherwise leave
   the headline stuck mid-fade. */
function fadeChars(spans, to, delay, step, dur){
  if (!spans.length) return;
  spans.forEach((s, i) => {
    s.style.transition = "opacity " + dur + "ms cubic-bezier(.33,0,.2,1) " + (delay + i * step) + "ms";
  });
  void spans[0].offsetWidth;
  spans.forEach(s => { s.style.opacity = to; });
}

/* The Greek runs much wider than the English. On narrow screens it cannot be
   shown on one line without shrinking the headline past what stays readable,
   and the ghost layer would be clipped at both edges — so there we skip the
   morph and simply fade the English in. */
function greekCanFit(){
  const lines = Array.prototype.slice.call(heroH1.querySelectorAll(".ln"));
  const prev = heroH1.style.fontSize;
  heroH1.style.fontSize = "";
  void heroH1.offsetWidth;
  let scale = 1;
  lines.forEach((ln, idx) => {
    const i = ln.querySelector("i");
    if (!i || !GREEK_LINES[idx]) return;
    const avail = ln.clientWidth;
    if (!avail) return;
    const w = measureText(GREEK_LINES[idx], i);
    if (w > avail) scale = Math.min(scale, avail / w);
  });
  heroH1.style.fontSize = prev;
  return scale >= FIT_MIN;
}

function runHeadlineMorph(){
  if (!heroH1 || reduceMotion) return;
  if (!greekCanFit()) return;
  const lines = Array.prototype.slice.call(heroH1.querySelectorAll(".ln"));
  const jobs = [];
  lines.forEach((ln, idx) => {
    const i = ln.querySelector("i");
    if (!i) return;
    const en = i.textContent.trim();
    i.dataset.en = en;
    /* the per-character spans own visibility now, so drop the CSS fade */
    i.style.animation = "none";
    i.style.opacity = "1";
    const ghost = document.createElement("span");
    ghost.className = "ln-ghost";
    ghost.setAttribute("aria-hidden", "true");
    ln.appendChild(ghost);
    jobs.push({
      i: i,
      en: en,
      ghost: ghost,
      greek: splitChars(GREEK_LINES[idx] || en, ghost),
      english: splitChars(en, i)
    });
  });
  if (!jobs.length) return;

  greekActive = true;
  fitHeadline(false);

  const STEP = 20, LINE_GAP = 170, HOLD = 1500;
  jobs.forEach((j, idx) => fadeChars(j.greek, "1", 150 + idx * LINE_GAP, STEP, 560));
  jobs.forEach((j, idx) => {
    setTimeout(() => {
      fadeChars(j.greek, "0", 0, STEP, 420);
      fadeChars(j.english, "1", 200, STEP, 520);
    }, HOLD + idx * LINE_GAP);
  });

  const last = jobs[jobs.length - 1];
  const total = HOLD + (jobs.length - 1) * LINE_GAP + 200 + last.english.length * STEP + 520 + 80;
  setTimeout(() => {
    jobs.forEach(j => {
      j.ghost.remove();
      j.i.textContent = j.en;   /* back to plain text once fully faded in */
    });
    greekActive = false;
    fitHeadline();              /* ease back up now that only English remains */
  }, total);
}

/* ============ ANNOUNCEMENT ROTATION ============ */
let mi = 0;
const announceEl = document.getElementById("announceMsg");
if (announceEl) setInterval(() => {
  announceEl.classList.add("fade");
  setTimeout(() => {
    mi = (mi + 1) % ANNOUNCE.length;
    announceEl.textContent = ANNOUNCE[mi];
    announceEl.classList.remove("fade");
  }, 400);
}, 4500);

/* ============ HEADER SHRINK + HERO VIDEO EXPANSION ============ */
const head = document.getElementById("siteHead");
let headH0 = 184, announceH = 33;
function measure(){
  const ann = document.querySelector(".announce");
  announceH = ann ? ann.offsetHeight : 0;
  headH0 = innerWidth <= 640 ? 140 : 184;
  document.documentElement.style.setProperty("--off", (announceH + headH0) + "px");
  document.documentElement.style.setProperty("--vhpx", innerHeight + "px");
}
measure();
let ticking = false, lastP = "", lastTop = -1;
function onScroll(){
  if (!head){ ticking = false; return; }
  head.classList.toggle("scrolled", scrollY > 40);
  /* the fixed header rides just below the announcement bar until it scrolls away */
  const topPx = Math.max(0, announceH - scrollY);
  if (topPx !== lastTop){ head.style.top = topPx + "px"; lastTop = topPx; }
  if (!reduceMotion){
    const expandLen = announceH + headH0 + 340;
    const p = Math.min(1, Math.max(0, scrollY / expandLen)).toFixed(4);
    if (p !== lastP){ document.documentElement.style.setProperty("--p", p); lastP = p; }
  }
  ticking = false;
}
addEventListener("scroll", () => { if (!ticking){ requestAnimationFrame(onScroll); ticking = true; } }, {passive:true});
addEventListener("resize", () => { measure(); fitHeadline(false); onScroll(); });
onScroll();

/* ============ THEME (light / dark) ============
   No stored choice = follow the device, and keep following it if the device
   flips while the page is open. The toggle stores an explicit choice, which
   then wins over the device until it is changed again. The pre-paint script
   in the layout applies the same rule before first render. */
const THEME_KEY = "ut-theme";
const darkQuery = matchMedia("(prefers-color-scheme: dark)");
const themeToggle = document.getElementById("themeToggle");
function storedTheme(){
  try { const v = localStorage.getItem(THEME_KEY); return v === "dark" || v === "light" ? v : null; }
  catch(e){ return null; }
}
function resolvedTheme(){ return storedTheme() || (darkQuery.matches ? "dark" : "light"); }
function applyTheme(){
  const root = document.documentElement;
  const stored = storedTheme();
  if (stored) root.setAttribute("data-theme", stored);
  else root.removeAttribute("data-theme");
  const resolved = resolvedTheme();
  root.setAttribute("data-resolved", resolved);
  /* keeps the mobile browser chrome in step (iOS Safari, Android Chrome) */
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", resolved === "dark" ? "#12181A" : "#FFFFFF");
  if (themeToggle){
    themeToggle.setAttribute("aria-pressed", resolved === "dark" ? "true" : "false");
    themeToggle.setAttribute("aria-label", resolved === "dark" ? "Switch to light mode" : "Switch to dark mode");
  }
}
if (themeToggle) themeToggle.addEventListener("click", () => {
  const next = resolvedTheme() === "dark" ? "light" : "dark";
  try { localStorage.setItem(THEME_KEY, next); } catch(e){}
  applyTheme();
});
const onSchemeChange = () => { if (!storedTheme()) applyTheme(); };
/* addListener is the pre-Safari 14 / older Android spelling */
if (darkQuery.addEventListener) darkQuery.addEventListener("change", onSchemeChange);
else if (darkQuery.addListener) darkQuery.addListener(onSchemeChange);
applyTheme();

/* ============ MENU ============ */
const menu = document.getElementById("menu");
const menuOpenBtn = document.getElementById("menuOpen");
function setMenu(open){
  if (!menu) return;
  menu.classList.toggle("open", open);
  if (menuOpenBtn) menuOpenBtn.setAttribute("aria-expanded", open);
  document.body.style.overflow = open ? "hidden" : "";
  /* focus the dialog, not its first link — focusing a link paints a focus
     ring on "Shop" every time the menu opens with the mouse */
  if (open){ applyTheme(); menu.focus(); }
  else if (menuOpenBtn) menuOpenBtn.focus();
}
if (menuOpenBtn) menuOpenBtn.addEventListener("click", () => setMenu(true));
const menuCloseBtn = document.getElementById("menuClose");
if (menuCloseBtn) menuCloseBtn.addEventListener("click", () => setMenu(false));
if (menu) menu.querySelectorAll("[data-menulink]").forEach(a => a.addEventListener("click", () => setMenu(false)));

/* ============ REVEALS ============ */
const io = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } });
}, {threshold:.18});
document.querySelectorAll(".rv").forEach(el => io.observe(el));

/* ============ REVIEWS — auto-scrolling infinite loop ============
   The quote set is repeated until a whole copy always sits beyond both edges,
   then scroll position is kept inside one copy's width and jumped by exactly
   one copy at the seams — invisible, and it can never run out of track.
   (With only two copies the strip hit its end before reaching the wrap point
   and stalled.) Auto-advances; pauses on hover/touch; mouse users can drag. */
const mwrap = document.querySelector(".mwrap");
const marquee = document.getElementById("marquee");
if (mwrap && marquee && marquee.children.length){
  const originals = Array.prototype.slice.call(marquee.children);
  let copyW = 0;

  function buildTrack(){
    const cs = getComputedStyle(marquee);
    const gap = parseFloat(cs.columnGap || cs.gap) || 0;
    copyW = originals.reduce((w, n) => w + n.getBoundingClientRect().width + gap, 0);
    if (copyW <= 0) return;
    /* need one copy of runway on each side of the visible window */
    let guard = 0;
    while (marquee.scrollWidth < copyW * 2 + mwrap.clientWidth + 8 && guard++ < 16){
      originals.forEach(n => marquee.appendChild(n.cloneNode(true)));
    }
    mwrap.scrollLeft = copyW;
  }
  buildTrack();
  addEventListener("resize", buildTrack);

  let hovering = false, dragging = false, dragX = 0, dragSL = 0;
  const wrapLoop = () => {
    if (copyW <= 0) return;
    if (mwrap.scrollLeft >= copyW * 2) mwrap.scrollLeft -= copyW;
    else if (mwrap.scrollLeft < copyW) mwrap.scrollLeft += copyW;
  };
  mwrap.addEventListener("scroll", wrapLoop, {passive:true});
  mwrap.addEventListener("pointerenter", e => { if (e.pointerType === "mouse") hovering = true; });
  mwrap.addEventListener("pointerleave", () => hovering = false);
  mwrap.addEventListener("pointerdown", e => {
    if (e.pointerType !== "mouse") { hovering = true; return; } /* touch scrolls natively */
    dragging = true; dragX = e.clientX; dragSL = mwrap.scrollLeft;
    mwrap.classList.add("dragging");
  });
  addEventListener("pointermove", e => {
    if (dragging) mwrap.scrollLeft = dragSL - (e.clientX - dragX);
  });
  const endDrag = () => { dragging = false; mwrap.classList.remove("dragging"); };
  addEventListener("pointerup", endDrag);
  addEventListener("pointercancel", endDrag);
  mwrap.addEventListener("touchend", () => setTimeout(() => hovering = false, 1500));

  let lastT = performance.now(), carry = 0;
  (function autoScroll(now){
    const dt = Math.min(64, now - lastT); lastT = now;
    if (!hovering && !dragging && !reduceMotion && copyW > 0){
      /* carry the sub-pixel remainder so slow drift is not rounded away */
      carry += dt * 0.032;
      const step = Math.floor(carry);
      if (step){ carry -= step; mwrap.scrollLeft += step; }
    }
    requestAnimationFrame(autoScroll);
  })(performance.now());
}

/* ============ ACCORDIONS ============ */
document.querySelectorAll(".acc-head").forEach(btn => {
  btn.addEventListener("click", () => {
    const acc = btn.closest(".acc");
    const open = acc.classList.toggle("open");
    btn.setAttribute("aria-expanded", open);
  });
});

/* ============ SHOPIFY CART ============ */
const cartCount = document.getElementById("cartCount");
const cDrawer = document.getElementById("cartDrawer");
let cartState = null;

async function cartFetch(url, opts){
  const res = await fetch(url, opts);
  if (!res.ok) throw new Error("cart request failed: " + res.status);
  return res.json();
}
const getCart = () => cartFetch("/cart.js");
const addToCart = (id, quantity) => cartFetch("/cart/add.js", {
  method:"POST", headers:{"Content-Type":"application/json"},
  body: JSON.stringify({items:[{id, quantity}]})
});
const changeLine = (key, quantity) => cartFetch("/cart/change.js", {
  method:"POST", headers:{"Content-Type":"application/json"},
  body: JSON.stringify({id:key, quantity})
});

function renderCart(){
  if (!cDrawer || !cartState) return;
  const items = document.getElementById("cartItems");
  const empty = document.getElementById("cartEmpty");
  items.innerHTML = "";
  const hasItems = cartState.item_count > 0;
  empty.style.display = hasItems ? "none" : "";
  cartState.items.forEach(item => {
    const row = document.createElement("div");
    row.className = "cart-item";
    const img = document.createElement("img");
    img.src = item.image || "";
    img.alt = "";
    const info = document.createElement("div");
    info.className = "ci-info";
    const b = document.createElement("b");
    b.textContent = item.product_title;
    const span = document.createElement("span");
    span.textContent = fmtCents(item.final_price);
    info.append(b, span);
    const qty = document.createElement("div");
    qty.className = "ci-qty";
    const minus = document.createElement("button");
    minus.textContent = "−"; minus.setAttribute("aria-label","Decrease quantity");
    minus.addEventListener("click", () => updateLine(item.key, item.quantity - 1));
    const q = document.createElement("span");
    q.textContent = item.quantity;
    const plus = document.createElement("button");
    plus.textContent = "+"; plus.setAttribute("aria-label","Increase quantity");
    plus.addEventListener("click", () => updateLine(item.key, item.quantity + 1));
    qty.append(minus, q, plus);
    row.append(img, info, qty);
    items.appendChild(row);
  });
  document.getElementById("cartSubtotal").textContent = fmtCents(cartState.items_subtotal_price);
  if (cartCount){
    cartCount.textContent = cartState.item_count;
    cartCount.classList.add("pop");
    setTimeout(() => cartCount.classList.remove("pop"), 350);
  }
}
async function refreshCart(){
  try { cartState = await getCart(); renderCart(); } catch(e){ /* offline / editor */ }
}
async function updateLine(key, quantity){
  try { cartState = await changeLine(key, Math.max(0, quantity)); renderCart(); } catch(e){}
}
function toast(title){
  const el = document.getElementById("toast");
  if (!el) return;
  el.textContent = "✓ " + title + " added to cart";
  el.classList.add("on");
  clearTimeout(toast._t);
  toast._t = setTimeout(() => el.classList.remove("on"), 2400);
}
async function addAndOpen(variantId, quantity, title){
  try {
    await addToCart(variantId, quantity);
    await refreshCart();
    toast(title);
    overlayOpen(cDrawer);
  } catch(e){}
}

/* ============ OVERLAYS (scrim + drawers) ============ */
const scrim = document.getElementById("scrim");
const pPanel = document.getElementById("productPanel");
let openEl = null;
function overlayOpen(el){
  if (!el) return;
  if (openEl && openEl !== el) openEl.classList.remove("open");
  openEl = el;
  el.classList.add("open");
  scrim.classList.add("on");
  document.body.style.overflow = "hidden";
}
function overlayClose(){
  if (openEl) openEl.classList.remove("open");
  openEl = null;
  scrim.classList.remove("on");
  document.body.style.overflow = "";
}
if (scrim) scrim.addEventListener("click", overlayClose);
document.querySelectorAll("[data-close-drawer]").forEach(b => b.addEventListener("click", overlayClose));
addEventListener("keydown", e => {
  if (e.key === "Escape"){
    if (menu && menu.classList.contains("open")) setMenu(false);
    else overlayClose();
  }
});
const cartOpenBtn = document.getElementById("cartOpen");
if (cartOpenBtn) cartOpenBtn.addEventListener("click", () => { refreshCart(); overlayOpen(cDrawer); });

/* ============ QUICK-VIEW PRODUCT PANEL ============ */
let pdHandle = null, pdQty = 1, pdImgIdx = 0;
function pdSetQty(n){
  pdQty = Math.max(1, n);
  const a = document.getElementById("pdQty"), b = document.getElementById("pdQtyM");
  if (a) a.textContent = pdQty;
  if (b) b.textContent = pdQty;
}
function pdShowImg(i){
  pdImgIdx = i;
  const gallery = document.getElementById("pdGallery");
  gallery.querySelectorAll("img").forEach((img, n) => img.classList.toggle("show", n === i));
  document.getElementById("pdDots").querySelectorAll("button").forEach((d, n) => d.setAttribute("aria-current", n === i));
}
function openProduct(handle){
  const p = PRODUCTS[handle];
  if (!p || !pPanel) return;
  pdHandle = handle;
  pdSetQty(1);
  document.getElementById("pdTitle").textContent = p.title;
  document.getElementById("pdNote").textContent = p.note || "";
  document.getElementById("pdPrice").textContent = fmtCents(p.price);
  document.getElementById("pdStory").textContent = p.desc || p.note || "";
  const gallery = document.getElementById("pdGallery");
  gallery.querySelectorAll("img").forEach(img => img.remove());
  const dots = document.getElementById("pdDots");
  dots.innerHTML = "";
  p.images.forEach((src, i) => {
    const img = document.createElement("img");
    img.src = src; img.alt = p.title;
    gallery.appendChild(img);
    const dot = document.createElement("button");
    dot.setAttribute("role","tab");
    dot.setAttribute("aria-label","Image " + (i + 1));
    dot.addEventListener("click", () => pdShowImg(i));
    dots.appendChild(dot);
  });
  pdShowImg(0);
  const relWrap = document.getElementById("pdRelWrap");
  const rel = document.getElementById("pdRel");
  rel.innerHTML = "";
  const others = Object.keys(PRODUCTS).filter(h => h !== handle).slice(0, 2);
  relWrap.style.display = others.length ? "" : "none";
  others.forEach(h => {
    const o = PRODUCTS[h];
    const btn = document.createElement("button");
    btn.className = "rel-card";
    const img = document.createElement("img");
    img.src = o.images[0] || ""; img.alt = "";
    const div = document.createElement("div");
    const b = document.createElement("b");
    b.textContent = o.title;
    const span = document.createElement("span");
    span.textContent = fmtCents(o.price);
    div.append(b, span);
    btn.append(img, div);
    btn.addEventListener("click", () => openProduct(h));
    rel.appendChild(btn);
  });
  overlayOpen(pPanel);
}
document.querySelectorAll("[data-product]").forEach(card => {
  card.addEventListener("click", e => {
    const quick = e.target.closest("[data-add]");
    if (quick){
      e.preventDefault();
      e.stopPropagation();
      const p = PRODUCTS[quick.dataset.add];
      if (p) addAndOpen(p.variantId, 1, p.title);
      return;
    }
    openProduct(card.dataset.product);
  });
});
document.querySelectorAll("[data-q]").forEach(b => b.addEventListener("click", () => pdSetQty(pdQty + parseInt(b.dataset.q, 10))));
["pdAdd","pdAddM"].forEach(id => {
  const btn = document.getElementById(id);
  if (btn) btn.addEventListener("click", () => {
    const p = PRODUCTS[pdHandle];
    if (p) addAndOpen(p.variantId, pdQty, p.title);
  });
});

/* ============ JOURNAL ARTICLE PANEL ============
   Cards stay real links, so middle click, cmd click and no-JS all still open
   the full article page. A plain click fetches the article's fragment-only
   template and slides it up instead; any failure falls through to the page. */
const articlePanel = document.getElementById("articlePanel");
const apContent = document.getElementById("apContent");
function panelUrl(url){ return url + (url.indexOf("?") > -1 ? "&" : "?") + "view=panel"; }
async function openArticle(url){
  if (!articlePanel || !apContent) return false;
  apContent.innerHTML = '<p class="ap-loading">Loading…</p>';
  overlayOpen(articlePanel);
  const scroller = articlePanel.querySelector(".panel-scroll");
  if (scroller) scroller.scrollTop = 0;
  try {
    const res = await fetch(panelUrl(url), { credentials: "same-origin" });
    if (!res.ok) throw new Error("HTTP " + res.status);
    const html = await res.text();
    if (!html.trim()) throw new Error("empty");
    apContent.innerHTML = html;
    if (scroller) scroller.scrollTop = 0;
    articlePanel.focus();
    return true;
  } catch (e){
    overlayClose();
    location.href = url;      /* the real page is always the fallback */
    return false;
  }
}
document.querySelectorAll("[data-article-url]").forEach(card => {
  card.addEventListener("click", e => {
    /* leave modified clicks alone so "open in new tab" keeps working */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    openArticle(card.dataset.articleUrl);
  });
});

/* ============ BOOT ============ */
(function(){
  /* In a background tab the timers that drive the morph are throttled, so the
     intro would play unseen. There the CSS fade alone shows the English. */
  if (!document.hidden) runHeadlineMorph();
  refreshCart();
})();
